import { apiServer } from 'settings/web-services/api';

export function getOfferClientVisibility(transactionId) {
  return apiServer.get(`/offer/client-visibility/${transactionId}`);
}
